(function () {
  const SUPABASE_URL = "https://tazpjdfnxmtcymbivlde.supabase.co";
  const SUPABASE_KEY = "sb_publishable_fS-OR1jMa_9LkdWFBKtNdA_lyGs_eLl";

  function initRecipeRatingSummaries() {
    const ratingElements = document.querySelectorAll(".recipe-rating-summary");

    if (!ratingElements.length) return;

    fetch(SUPABASE_URL + "/rest/v1/recipe_ratings?select=id,article_slug,rating", {
      headers: {
        "apikey": SUPABASE_KEY,
        "Authorization": "Bearer " + SUPABASE_KEY
      }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        const grouped = {};

        data.forEach(function (item) {
          if (!grouped[item.article_slug]) {
            grouped[item.article_slug] = [];
          }

          grouped[item.article_slug].push(Number(item.rating));
        });

        ratingElements.forEach(function (el) {
          const slug = el.dataset.articleSlug;
          const ratings = grouped[slug] || [];

          const starsEl = el.querySelector(".recipe-rating-summary__stars");
          const avgEl = el.querySelector(".recipe-rating-summary__avg");
          const countEl = el.querySelector(".recipe-rating-summary__count");

          if (!starsEl || !avgEl || !countEl) return;

          function paintStars(value) {
            let stars = "";

            for (let i = 1; i <= 5; i++) {
              stars += i <= value ? "★" : "☆";
            }

            starsEl.textContent = stars;
          }

          if (!ratings.length) {
            paintStars(0);
            avgEl.textContent = "0,0";
            countEl.textContent = "0";
            return;
          }

          const total = ratings.reduce(function (sum, rating) {
            return sum + rating;
          }, 0);

          const average = total / ratings.length;

          paintStars(Math.round(average));
          avgEl.textContent = average.toFixed(1).replace(".", ",");
          countEl.textContent = ratings.length;
        });
      })
      .catch(function (error) {
        console.error("Rating summary load error:", error);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRecipeRatingSummaries);
  } else {
    initRecipeRatingSummaries();
  }
})();